import React from 'react';
import { locales } from '../translations/locales';

const Cookies = (props) => {
    const { session, locale } = props;

    return (
        <div id="confirm-cookies" className="confirm-cookies">
            <p>
                {locales[locale].cookie.a}
                <a href="/documents/informations-cookies" alt="Infos cookies">
                    {locales[locale].cookie.b}
                </a>
                {locales[locale].cookie.c}
                <button className="btn-confirm-cookies" onClick={() => session.acceptCookies()}>
                    {locales[locale].cookie.btn}
                </button>
            </p>
        </div>
    );
};

export default Cookies;
